<section class="page-title-area">
    <div class="container">
        <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea">
            <h2>{{ pageTitle.title }}</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>{{ pageTitle.title }}</li>
            </ul>
        </div>
    </div>

    <div class="shape-img1">
        <img src="assets/img/shape/shape1.svg" alt="image" />
    </div>
    <div class="shape-img2">
        <img src="assets/img/shape/shape2.png" alt="image" />
    </div>
    <div class="shape-img3">
        <img src="assets/img/shape/shape3.png" alt="image" />
    </div>
</section>

<section class="faq-area ptb-100">
    <div class="container" *ngIf="searchResults || searchResults.length > 0">
        <div class="faq-accordion">
            <ul class="accordion">
                <li class="accordion-item" *ngFor="let result of searchResults">
                    <a class="accordion-title" routerLink="/{{ result.url }}">
                        <i class="flaticon-loupe"></i>
                        {{ result.title }}
                    </a>

                    <div class="accordion-content">
                        <p>{{ result.description }}</p>
                        <p class="target-link">{{ rootUrl }}{{ result.url }}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <div
        class="container no-results"
        *ngIf="!searchResults || searchResults.length === 0"
    >
        <i class="flaticon-loupe"></i> Sorry, we couldn't find any results.
    </div>
</section>
